import { JSX } from 'react'


import { HttpBody } from '@/lib/request.js'

import * as contract_storage from '@/storage/contract.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export default function
(
	props: {
		doc: HttpBody<contract_storage.TRawDocumentType>

		update(name: string, value: unknown): void

	},

)
:	JSX.Element
{
	let { bank, outlet, serial, name, phone, original } = props.doc

	let on_update = (name_: string, value: unknown): void =>
	{
		props.update(name_, value)

	}

	return (
		<Fieldset.Root divide name="附件信息">
			<Fieldset.Group>
				<Field.Text label="开户行" name="bank" value={bank} change={on_update} />

				<Field.Text label="开户网点" name="outlet" value={outlet} change={on_update} />
			</Fieldset.Group>

			<Fieldset.Group>
				<Field.Text label="银行卡号" name="serial" value={serial} change={on_update} />

				<Field.Text label="银行卡所属人姓名" name="name" value={name} change={on_update} />

				<Field.Text label="银行卡所属人手机号码" name="phone" value={phone} change={on_update} />

				<Field.Image label="银行卡原件" name="original" thumbnail={original} change={on_update} />

			</Fieldset.Group>

		</Fieldset.Root>

	)

}
